import { render, staticRenderFns } from "./chipin.vue?vue&type=template&id=ca39f24c&"
import script from "./chipin.vue?vue&type=script&lang=js&"
export * from "./chipin.vue?vue&type=script&lang=js&"
import style0 from "./chipin.vue?vue&type=style&index=0&id=ca39f24c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports